import type { Ari } from '@atlassian/jira-platform-ari/src/index.tsx';
import { JiraProjectAri } from '@atlassian/ari/jira/project';
import { AnyAri } from '@atlassian/ari/any-ari';
import { getCloudIdFromDocument } from '../meta-extractors/index.tsx';

/**
 * Generates ARI from a project ID
 * @param projectId - The project ID to convert to ARI
 * @returns The project ARI string or null if conversion fails
 */
export const getProjectAri = (projectId: string): Ari | null => {
	const cloudId = getCloudIdFromDocument();
	if (!projectId || !cloudId) {
		return null;
	}

	try {
		return JiraProjectAri.create({
			siteId: cloudId,
			projectId,
		}).toString();
	} catch (error) {
		// Return null if ARI creation fails (e.g., invalid projectId format)
		return null;
	}
};

/**
 * Generates view ARI from a view ID
 * @param viewId - The view ID to convert to ARI
 * @returns The view ARI string or null if conversion fails
 */
export const getViewAri = (viewId: string): Ari | null => {
	const cloudId = getCloudIdFromDocument();
	if (!viewId || !cloudId) {
		return null;
	}

	try {
		return AnyAri.create({
			resourceOwner: 'jira',
			cloudId,
			resourceType: 'view',
			resourceId: viewId,
		}).toString();
	} catch (error) {
		// Return null if ARI creation fails (e.g., invalid viewId format)
		return null;
	}
};
